import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Link, Redirect } from 'react-router-dom';
import LaddaButton, {EXPAND_RIGHT} from 'react-ladda';
import { authActions } from "../../../common/redux/actions";
import { Main } from '../../layout';
import SimpleReactValidator from 'simple-react-validator';
import { DocumentTitle } from '../../../helpers';
import { globalService as gs } from '../../../common/services';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login';

class Login extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            formField: {
                username: '',
                password: '',
            },
            isSignedIn: false,
            isSignedInNormal: true,
            submitted: false,
            loading: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
            messages: {
                password_repeat: 'Confirm Password is required.'
            }
        });
    }

    componentDidMount() {
        
    }

    handleChange = (e) => {
        let formField = {...this.state.formField};
        formField[e.target.name] = e.target.value;
        this.setState({formField});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField } = this.state;        
        if(this.validator.allValid()) {
            this.setState({ isSignedInNormal: false });
            const { dispatch } = this.props;
            dispatch(authActions.login(formField));
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    resendVerification = () => {
        const {dispatch, alert} = this.props;
        dispatch(authActions.resendVerification({user_id: alert.user_id}, {user_id: alert.user_id}));
    }

    responseGoogle = (response) => {
        const {dispatch} = this.props;
        //console.log('response', response)
        if(response && response) {
            const params = {
                googleId: response.googleId,
                imageUrl: response.profileObj.imageUrl,
                email: response.profileObj.email,
                name: response.profileObj.name,
                givenName: response.profileObj.givenName,
                familyName: response.profileObj.familyName
            }
            dispatch(authActions.loginByAuth(params, {authclient: 'google'}));
        }
    }

    responseFacebook = (response) => {
        const {dispatch} = this.props;
        console.log('responseFacebook', response);
        (response && response.accessToken) && dispatch(authActions.loginByAuth(response, {authclient: 'facebook'}));
    }

    render() {
        this.validator.purgeFields();
        const { formField } = this.state;
        const { username, password } = formField;
        const { alert } = this.props;
        if (gs.identity) {
            return (<Redirect to='/'/>)
        }
        
        return (<Main>
            <DocumentTitle title={`Login`}/>
            <section className="login-page my-5 py-5" style={{backgroundImage: `url(/images/login-full.png)`}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="login-box">
                                <h1 className="text-left mb-4">Login</h1>
                                {/* {(gs.errors.length > 0) && <div>
                                    {gs.errors.map(error => error)}
                                </div>} */}
                                <form name="form" onSubmit={this.handleSubmit} noValidate>
                                    <div className="form-group">
                                        <label>Email<span className="text-danger">*</span></label>

                                        <input type="text" className="form-control" name="username" defaultValue={username} placeholder="Enter Your Email Address" onChange={this.handleChange} />
                            
                                        {this.validator.message('username', formField.username, 'required')}
                                    </div>
                                    <div className="form-group">
                                        <label>Password<span className="text-danger">*</span></label>
                                        
                                        <input type="password" className="form-control" name="password" defaultValue={password} placeholder="Enter Your Password" onChange={this.handleChange} />
                                            
                                        {this.validator.message('password', password, 'required')}
                                        
                                    </div>
                                    <div className="form-group justify-content-between align-items-center d-flex">
                                        <div className="form-check">                                            
                                            <FormControlLabel
                                                control={<Checkbox id="gridCheck" className="" name="checkedA" />}
                                                label="Remember Me"
                                                
                                            />
                                        </div>
                                        <small className="form-text text-muted text-right forgot">
                                            <Link to="/forgot-password">Forgot Password?</Link>
                                        </small>
                                    </div>
                                    <div className="form-group mb-4">
                                        <LaddaButton className="btn btn-primary w-100  py-3 font-weight-bold" loading={this.props.process.loading} data-style={EXPAND_RIGHT}>Login</LaddaButton>
                                    </div>
                                    {(alert && alert.user_id) &&
                                    <div className="form-group text-center" style={{fontSize: '12px'}}>
                                        Your Email is not verified yet. If you did not received a verification email then please click
                                        <button className="btn btn-info btn-sm" type="button" onClick={this.resendVerification}>Resend</button>
                                    </div>}
                                    
                                        {/* <button type="button" className="btn btn-facebook d-flex justify-content-center align-items-center">
                                            <div className="img">
                                            <img src="/images/svg/Facebook-login.svg" alt="Facebook" /> </div>Facebook 
                                            
                                        </button> */}
                                         
                                         <div className="form-group mb-4 text-center font-weight-bold">OR</div>
                                       
                                         <div className="form-group mb-4">
                                            <GoogleLogin
                                                clientId="291098488453-hcs6cl88m741mil9uqp7ah5p8t7ssdt7.apps.googleusercontent.com"
                                                buttonText="Google"
                                                render={renderProps => (
                                                    <button className="btn btn-google ml-0 d-flex justify-content-center align-items-center w-100"
                                                    onClick={renderProps.onClick} 
                                                    disabled={renderProps.disabled}>
                                                        <div className="img" >
                                                            <img src="/images/Google__G__Logo.webp" alt="Gicon" className="icon" /> 
                                                            </div> Sign in with Google
                                                    </button>
                                                )}
                                                onSuccess={this.responseGoogle}
                                                onFailure={this.responseGoogle}
                                                cookiePolicy={'single_host_origin'}
                                            />
                                        </div>
                                        {/* <div className="form-group mb-4">
                                            <FacebookLogin
                                            appId="2884942965164452"
                                            autoLoad={true}
                                            fields="name,email,picture"
                                            cssClass="btn btn-facebook d-flex justify-content-center align-items-center w-100" 
                                            textButton="Sign in with Facebook"                                            
                                            callback={this.responseFacebook}>
                                                <div className="img">
                                                <img src="/images/logo-facebook.png" alt="Facebook" /> </div>
                                            </FacebookLogin>
                                         </div> */}                                  
                                    <div className="form-group mb-0 account text-center">
                                        Don't have an Account? <Link to={'/register'}>Please Register</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <div className="col-lg-8 col-md-6 col-sm-6 col-12">
                            <div className="image">
                                <img className="img-fluid" src="/images/login.png" alt="Login" />
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </Main>);
    }
}

const authSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const processSelector = createSelector(
    state => state.process,
    process => process
);

const alertSelector = createSelector(
    state => state.alert,
    alert => alert
);

const mapStateToProps = createSelector(
    authSelector,
    processSelector,
    alertSelector,
    (authentication, process, alert) => ({
        authentication, process, alert
    })
);

export default connect(mapStateToProps)(Login);